module.exports = __webpack_public_path__ + "assets/lessons/pl/lesson2/pages/lesson_2_09.pdf";